<div class="form-text"
    [ngClass]="{ 'text-align-left': alignLeft }">
    {{ subtitle }}
</div>
